module.exports = __webpack_public_path__ + "img/flag-icon-ko.dc351ef0.svg";